import {
  Module,
  VuexModule,
  Action,
  Mutation,
  getModule
} from 'vuex-module-decorators'
import Vue from 'vue'
import axios from 'axios'

import store from '@/store'
import dashboardModule from '@/store/dashboard'
import listModule, { ListType } from '@/store/list'
import whitelabelModule from '@/store/whitelabel'
import { Venue } from '@/types/Company'
import { Whitelabel } from '@/types/Whitelabel'
import { isEmpty } from 'lodash'

const name = 'venue'

@Module({
  namespaced: true,
  dynamic: true,
  name,
  store
})
class VenueModule extends VuexModule {
  private currentVenue?: Venue
  private allVenues: Venue[] = []
  private allCities: string[] = []

  private get whitelabel(): Whitelabel {
    return whitelabelModule.whitelabel
  }

  get venue(): Venue | undefined {
    return this.currentVenue
  }

  get venues(): Venue[] {
    return this.allVenues
  }

  get cities(): string[] {
    return this.allCities
  }

  @Mutation
  setCurrentVenue(payload: Venue) {
    Vue.set(this, 'currentVenue', payload)
  }
  @Mutation
  setAllVenues(payload: Venue[]) {
    Vue.set(this, 'allVenues', payload)
  }
  @Mutation
  setAllCities(payload: string[]) {
    Vue.set(this, 'allCities', payload.sort())
  }

  @Action({ rawError: true })
  async fetch(id: string) {
    try {
      const { data } = await axios.get(
        `/admin/${this.whitelabel.slug}/venue/${id}`
      )
      this.context.commit('setCurrentVenue', data)
    } catch (error) {
      dashboardModule.newError('Geschäft konnte nicht geladen werden')
    }
  }

  @Action({ rawError: true })
  async fetchAll(params: {
    limit: number
    q?: string
    page?: number
    companyId?: string
    lean?: boolean
    sortBy?: string
    sortDesc?: boolean
  }) {
    try {
      if (!isEmpty(listModule.allFilters[ListType.Venue])) {
        Object.assign(params, { filter: listModule.allFilters[ListType.Venue] })
      }

      const { data } = await axios.post(
        `/admin/${this.whitelabel.slug}/venue/list`,
        params
      )
      this.context.commit('setAllVenues', data.venues || data)
      return data.page_count
    } catch (error) {
      dashboardModule.newError('Geschäfte konnten nicht geladen werden')
    }
  }

  @Action({ rawError: true })
  async fetchAllCities() {
    try {
      const { data } = await axios.get(
        `/admin/${this.whitelabel.slug}/venue/cities`
      )
      this.context.commit('setAllCities', data.cities)
    } catch (error) {
      dashboardModule.newError('Städte konnten nicht geladen werden')
    }
  }

  @Action({ rawError: true })
  async create(payload: {
    whitelabel: string
    company: string
    venue: Partial<Venue>
  }) {
    try {
      const { data } = await axios.post(
        `/admin/${payload.whitelabel}/company/${payload.company}/venue`,
        payload.venue
      )
      this.context.commit('setCurrentVenue', data)
      this.fetchAll({ limit: listModule.perPage })
      dashboardModule.newMessage('Geschäft wurde erfolgreich erstellt')
    } catch (error) {
      dashboardModule.newError('Geschäft konnte nicht erstellt werden')
    }
  }

  @Action({ rawError: true })
  async update(payload: { whitelabel: string; venue: Partial<Venue> }) {
    try {
      const { data } = await axios.put(
        `/admin/${payload.whitelabel}/venue/${payload.venue._id}`,
        payload.venue
      )
      this.context.commit('setCurrentVenue', data.venue)
      dashboardModule.newMessage('Geschäft wurde erfolgreich aktualisiert')
    } catch (error) {
      dashboardModule.newError('Geschäft konnte nicht aktualisiert werden')
    }
  }

  @Action({ rawError: true })
  setVenue(payload: Venue) {
    this.context.commit('setCurrentVenue', payload)
  }
}

export default getModule(VenueModule)
